import { ViewMode } from '../api/types/types';
import rootStore from 'store/root.store';

enum ControlKeys {
    CTRL = 'CTRL',
    CMD = 'CMD',
    UNKNOWN = ''
};

export enum Pages {
    HOME = '/home',
    TIMEENTRIES = '/timeentries',
    MATTERS = '/matters',
    TEMPLATES = '/templates',
    TIMERS = '/timers',
    NARRATIVES = '/narratives',
    PROJECT_TIME = '/management/project-time',
    DRAFT_TIME = '/management/draft-time',
    REPORTS = '/reports',
    SETTINGS = '/settings/general'
};

// CMD or Ctrl
export const MainNavigationHotkeys: { [key: string]: string } = {
    '1': Pages.HOME,
    '2': Pages.TIMEENTRIES,
    '3': Pages.MATTERS,
    '4': Pages.TEMPLATES,
    '5': Pages.TIMERS,
    '6': Pages.NARRATIVES,
    '7': Pages.PROJECT_TIME,
    '8': Pages.DRAFT_TIME,
    '9': Pages.REPORTS,
    '0': Pages.SETTINGS
};

// CMD or Ctrl
export const HomePageNavHotkeys: { [key: string]: ViewMode } = {
    'd': ViewMode.DAY,
    'e': ViewMode.WEEK,
    'm': ViewMode.MONTH,
    'g': ViewMode.GRID
};

export enum HomePageAction {
    TODAY = 'TODAY',
    START_TIMER = 'START_TIMER',
    NEW_TIMEENTRY = 'NEW_TIMEENTRY'
};

// CMD or Ctrl + Shift
export const HomePageActionHotkeys: { [key: string]: HomePageAction } = {
    'p': HomePageAction.TODAY,
    's': HomePageAction.START_TIMER,
    'l': HomePageAction.NEW_TIMEENTRY
};

// CMD or Ctrl + Shift
export const GeneralNavigationHotKeys: {[key: string]: string} = {
    Fab: 'a'
};

// handle Enter or Space key press
export const handleEnterKey = (event: React.KeyboardEvent<Element>, action: () => void) => {
    if ((event.key === 'Enter' || event.key === ' ') && !event.ctrlKey && !event.shiftKey) {
        event.preventDefault();
        event.stopPropagation();
        action();
    }
}

// handle Esc key press
export const handleEscapeKey = (event: React.KeyboardEvent<Element>, rightPanel: HTMLElement | null, fabContianer?: HTMLElement | null) => {
    if (event.key === 'Escape' && !event.shiftKey && !event.ctrlKey) {
        const { previousActiveElements, focusPreviousActiveElement, activeElementBeforeFab } = rootStore!.appStore;
        if (fabContianer && fabContianer.contains(document.activeElement)) {
            event.nativeEvent.stopImmediatePropagation();
            activeElementBeforeFab.focus();
        } else if (rightPanel) {
            const rightPanelFocused = rightPanel.contains(document.activeElement);
            if (rightPanelFocused && previousActiveElements.length > 0) {
                event.nativeEvent.stopImmediatePropagation();
                focusPreviousActiveElement();
            }
        }
    }
}

export const isControlKeyDown = (ctrl: boolean, cmd: boolean) => {
    return (navigator.platform.startsWith('Win') && ctrl) || (navigator.platform.startsWith('Mac') && cmd);
}

export const getControlKey = () => {
    return navigator.platform.startsWith('Win') ? 'CTRL' : navigator.platform.startsWith('Mac') ? 'CMD' : '';
}